export default {
    name: 'Ordering',

    props: {
        operation: {
            type: Object,
            required: true
        }
    },

    methods: {
        /**
         * Get payer full name
         * @return {String} payer full name
         */
        getPayerFullName() {
            return `${this.operation.payer.name} ${this.operation.payer.lastname_1} ${this.operation.payer.lastname_2 || ''}`;
        }
    }
};
